import { MODULE } from "./progressFilter.actionTypes";

export const getSelectedProgress = (state) => state.getIn([MODULE, "selectedProgress"]);
